import { Charge } from 'interfaces';

// canceled (hidden) charges are excluded - the backend also skips them when invoicing
export const countChargesTotalAmount: (charges: Charge[]) => number = charges =>
   charges.reduce(
      (totalAmount, charge) =>
         charge.hidden ? totalAmount : totalAmount + (charge.totalAmount || 0),
      0,
   );
